/**
 * Bot Detection Script
 * Sends bot detection data to GA4 when a crawler/bot is detected
 */
(function () {

  // Ensure gtag exists
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}

  // Replace with your GA4 measurement ID
  gtag('config', 'G-NRWGTW9QV9');

  // Get user agent
  var ua = (navigator.userAgent || '').toLowerCase().trim();

  // Bot detection regex
  var botRegex = /bot|crawl|spider|slurp|mediapartners|google-extended|gptbot|claudebot|perplexitybot|facebookexternalhit|linkedinbot|embedly|quora|redditbot|ia_archiver|sogou|twitterbot|applebot|bytespider|semrushbot|ahrefsbot|mj12bot|petalbot|dotbot|serpstatbot|yandexbot|baiduspider|duckduckbot/i;

  var isBot = botRegex.test(ua);

  // Only send event if bot is detected
  if (isBot) {
    // Prepare payload
    var botData = {
      is_bot: isBot,
      user_agent: ua,
      timestamp: new Date().toISOString()
    };

    // Send event to GA4
    gtag('event', 'crawler_detected', {
      is_bot: botData.is_bot,
      user_agent: botData.user_agent,
      timestamp: botData.timestamp
    });
  }

})();
